import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';


const DNCParamTable = ({ selectable, selectDNCParam, selectedDNCParams }) => {
    const [dncParamResultsData, setDNCParamResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from dnc_param;", setDNCParamResultsData)
    }, []);

    const dncParamResultsColumns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 340,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-dnc-param?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'name',
            headerName: 'Full Name',
            width: 180,
        },
        {
            field: 'reference_name',
            headerName: 'Ref Name',
            width: 140,
        },
        {
            field: 'min_value',
            headerName: 'Min Value',
            width: 140,
        },
        {
            field: 'max_value',
            headerName: 'Max Value',
            width: 140,
        },
        {
            field: 'parent_path',
            headerName: 'Parent Path',
            width: 540,
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 440,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let dncParamResultsDataRows = dncParamResultsData?.filter(data => data != null).map((dncParamResults) =>
    ({   
        id: dncParamResults.id,
        name: dncParamResults.name,
        reference_name: dncParamResults.reference_name,
        min_value: dncParamResults.min_value,
        max_value: dncParamResults.max_value,
        parent_path: dncParamResults.parent_path,
        description: dncParamResults.description,
        created_date: dncParamResults.created_date
    }))


    if (dncParamResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={dncParamResultsDataRows}
            columns={dncParamResultsColumns}
            checkboxSelection={selectable}
            selectionModel={selectedDNCParams}
            onSelectionModelChange={(selectedDNCParam) => {
                selectDNCParam(selectedDNCParam)
            }}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }],
              },
            }}
            autoHeight
      />
    )
};

export { DNCParamTable };
